module.exports = __webpack_public_path__ + "img/tu4.dab4f34c.png";